const getBearerToken = (): { headers: { Authorization: string } } => {
  const token = localStorage.getItem('id_token') || null;
  return { headers: { Authorization: `Bearer ${token}` } };
};

export default getBearerToken;
